import React from "react";

import { themeColor } from "src/styles";

import { translate } from "react-i18next";

import { Box, ButtonLink, Flex, Link, Text } from "./base";

const RelatedLinks = ({
  links,
  t,
  title = t("layout.relatedLinksTitle"),
  theme,
  listProps,
  itemProps,
  titleProps,
  ...props
}) => (
  <Box {...props}>
    <Text textTransform="uppercase" fontWeight="bold" {...titleProps}>
      {title}
    </Text>
    <Flex mt={2} flexDirection="column" {...listProps}>
      {links.map((link, index) => {
        return link.showAsButton ? (
          <ButtonLink
            to={link.url}
            mt={2}
            key={link.url}
            align="center"
            style={{ display: "block" }}
          >
            {link.name}
          </ButtonLink>
        ) : (
          <Link
            key={link.url}
            to={link.url}
            textDecoration="none"
            color={themeColor(theme)}
            mt={2}
            fontWeight="semibold"
            activeStyle={{
              fontWeight: "700",
            }}
            hover={{
              textDecoration: "underline",
            }}
            exact={link.exact}
            {...itemProps}
          >
            {link.name}
          </Link>
        );
      })}
    </Flex>
  </Box>
);

export default translate("translations")(RelatedLinks);

export const relatedLinkFragment = graphql`
  fragment RelatedLink on ContentfulLink {
    name
    url
    showAsButton
  }
`;



// WEBPACK FOOTER //
// ./src/components/RelatedLinks.js